var render = function render(){var _vm=this,_c=_vm._self._c;return _c('app-layout',{attrs:{"title":""},scopedSlots:_vm._u([{key:"body",fn:function(){return [_c('div',{staticClass:"access-denied"},[_c('v-icon',{attrs:{"size":"5rem"}},[_vm._v("mdi-lock")]),_c('span',{staticClass:"description"},[_vm._v(" You don't have permission to view this page ")])],1)]},proxy:true}])})
}
var staticRenderFns = []

export { render, staticRenderFns }